import { IconFont } from '@/components/IconFont'
import { getInvitationPending, deleteInvitation } from '@/services/member/member'
import { Invitation } from '@/services/member/member.model'
import { textIncludes } from '@/utils/utils'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { Col, Input, Modal, Row, Table } from 'antd'
import classnames from 'classnames'
import dayjs from 'dayjs'
import { memo, useContext, useMemo, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { OrganizationContext } from '../..'

const { Column } = Table

export default memo(function OrganizationPendingInvitations() {
  const [filterValue, setFilterValue] = useState('')
  const orgData = useContext(OrganizationContext).orgData!
  const { data: invitations = [], refresh: invitationRefresh } = useRequest(() =>
    getInvitationPending('organizations', orgData.id)
  )
  const filterInvitations = useMemo(() => {
    return invitations.filter((invitation) => textIncludes(invitation.email, filterValue))
  }, [invitations, filterValue])

  return (
    <div>
      <Row justify={'end'}>
        <Col>
          <Input
            value={filterValue}
            placeholder='Search'
            className={'mr-1'}
            style={{ width: '200px' }}
            prefix={<IconFont type={'icon-search'} />}
            onChange={(event) => {
              const value = event.target.value
              setFilterValue(value)
            }}
          />
        </Col>
      </Row>

      <div className={classnames('mt-2')}>
        <Table bordered size='small' dataSource={filterInvitations} rowKey={(record) => record.id}>
          <Column title='Email' dataIndex='email' key='email' align={'center'} />

          <Column
            title='Create time'
            dataIndex='createTime'
            key='createTime'
            align={'center'}
            render={(value) => dayjs(value).format('MMM D, YYYY')}
          />

          <Column
            title='Operation'
            dataIndex='title'
            key='title'
            align={'center'}
            render={(_, record: Invitation.Pending) => (
              <IconFont
                type='icon-shanchu'
                onClick={() => {
                  Modal.confirm({
                    icon: <ExclamationCircleOutlined />,
                    content: 'Are you sure to delete?',
                    onOk: async () => {
                      await deleteInvitation(record.id)
                      invitationRefresh()
                    }
                  })
                }}
              />
            )}
          />
        </Table>
      </div>

      <Outlet />
    </div>
  )
})
